"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mock = void 0;
// Mock middleware that always terminates request chain
// so it can be used only in tests
// in future it may be good to implement things like recording but it is out of current scope
const mock = mocks => {
    return (ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
        const mock = mocks.find(m => m.when(ctx));
        if (!mock)
            throw new Error(`No mock defined for request to ${ctx.input}`);
        ctx.response = yield mock.then(ctx);
    });
};
exports.mock = mock;
//# sourceMappingURL=mock.js.map